import React from 'react';
import LinkButton from '../LinkButton';
import styles from './ClinicPaid.css';
import StaticNavigation from './StaticNavigation';

const ClinicPaid = () => (
  <div>
    <StaticNavigation title="412" />
    <div className={styles.container}>
      <p className={styles.message}>
        The refill you requested has been paid by clinic and
      </p>
      <p className={styles.message}>
        cannot be processed online. Please call customer service
      </p>
      <p className={styles.phone}>1-800-1234</p>
      <LinkButton to="/" className={styles.button}>
        <span>Return Home</span>
      </LinkButton>
    </div>
  </div>
);

export default ClinicPaid;



// WEBPACK FOOTER //
// ./src/components/StaticPages/ClinicPaid.jsx